/*
 *==================================================
 * Licensed Materials - ADIACENT
 *
 * CR022 Autodesk Vault - CAD Download Basket
 *
 *==================================================
 */
//Standard libraries
import { call, put } from "redux-saga/effects";
//Foundation libraries
import cadBasketService from "../../../components/apis/transaction/cadbasket.service";
//Redux
import {
  CAD_BASKET_GET_REQUESTED_ACTION,
  CAD_BASKET_GET_SUCCESS_ACTION,
  CAD_BASKET_GET_ERROR_ACTION,
  CAD_BASKET_ZIP_SUCCESS_ACTION,
  CAD_PDP_EXCLUSIONS_RESET_ACTION,
} from "../../actions/cadBasket";
import { GENERIC_ERROR_ACTION } from "../../actions/error";
import { HANDLE_SUCCESS_MESSAGE_ACTION } from "../../actions/success";
import { GENERIC_ERROR_CODE, GENERIC_ERROR_KEY } from "../../../constants/errors";
import { SUCCESS_MSG_PREFIX } from "../../../constants/common";
import { CAD_ITEM_ADD_SUCCESS, CAD_ITEM_REMOVE_SUCCESS } from "../../action-types/cadBasket";

export function* getCadBasket(action: any) {
  const { storeId } = action.payload;
  try {
    const response = yield call(cadBasketService.getBasket, storeId);
    yield put(CAD_BASKET_GET_SUCCESS_ACTION(response.data));
  } catch (e) {
    yield put(CAD_BASKET_GET_ERROR_ACTION(e));
  }
}

export function* addCadBasketItem(action: any) {
  const { storeId, materialPartNum, materialMnfPartNum, excludedAttachmentIds } = action.payload;
  try {
    yield call(cadBasketService.addItem, storeId, materialPartNum, excludedAttachmentIds);
    /** the exclusion selection has been persisted with the item: clear the PDP-transient state */
    yield put(CAD_PDP_EXCLUSIONS_RESET_ACTION({}));
    yield put(CAD_BASKET_GET_REQUESTED_ACTION({ storeId }));
    /** mimic add-to-cart: success snackbar + the Header opens the mini CAD basket on this key */
    yield put(HANDLE_SUCCESS_MESSAGE_ACTION({
      key: SUCCESS_MSG_PREFIX + CAD_ITEM_ADD_SUCCESS,
      messageParameters: { mnfPartNumber: materialMnfPartNum },
    }));
  } catch (e) {
    yield put(GENERIC_ERROR_ACTION(buildError(e, "ERROR to add the material to the CAD Download Basket.")));
  }
}

export function* removeCadBasketItem(action: any) {
  const { storeId, itemId, materialPartNum, materialMnfPartNum } = action.payload;
  try {
    if (itemId) {
      yield call(cadBasketService.removeItemById, storeId, itemId);
    } else {
      yield call(cadBasketService.removeItemByPartNum, storeId, materialPartNum);
    }
    yield put(CAD_BASKET_GET_REQUESTED_ACTION({ storeId }));
    yield put(HANDLE_SUCCESS_MESSAGE_ACTION({
      key: SUCCESS_MSG_PREFIX + CAD_ITEM_REMOVE_SUCCESS,
      messageParameters: { mnfPartNumber: materialMnfPartNum },
    }));
  } catch (e) {
    yield put(GENERIC_ERROR_ACTION(buildError(e, "ERROR to remove the material from the CAD Download Basket.")));
  }
}

export function* emptyCadBasket(action: any) {
  const { storeId } = action.payload;
  try {
    yield call(cadBasketService.emptyBasket, storeId);
    yield put(CAD_BASKET_GET_REQUESTED_ACTION({ storeId }));
  } catch (e) {
    yield put(GENERIC_ERROR_ACTION(buildError(e, "ERROR to empty the CAD Download Basket.")));
  }
}

export function* requestCadBasketZip(action: any) {
  const { storeId } = action.payload;
  try {
    yield call(cadBasketService.requestZip, storeId);
    yield put(CAD_BASKET_ZIP_SUCCESS_ACTION({}));
    yield put(CAD_BASKET_GET_REQUESTED_ACTION({ storeId }));
  } catch (e) {
    yield put(GENERIC_ERROR_ACTION(buildError(e, "ERROR to request the CAD assets ZIP.")));
  }
}

function buildError(e: any, message: string) {
  return {
    errorKey: GENERIC_ERROR_KEY,
    errorCode: GENERIC_ERROR_CODE,
    handled: false,
    errorMessage: e?.toString() + " || " + message,
  };
}
